// One dismissable summary chip rendered inside MarketplaceResultsBar.
// Each chip carries the spread result from `activeFilterChips`
// (`id` + `label`); click fires `removeFilterChip(host, id)` which
// branches by id prefix (`kind` / `pricing` / `query` / `cat:<value>`).

export const MarketplaceFilterChip = {
  flow: 'x',
  align: 'center',
  gap: 'X',
  padding: 'X Y',
  borderRadius: 'Y',
  background: 'line',
  color: 'title',
  fontSize: 'Y',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  ':hover': { background: 'blue.2' },

  onClick: (e, el) => {
    const host = el.call('marketplaceHostOf', el)
    el.call('removeFilterChip', host, el.id)
  },

  ChipLabel: {
    tag: 'span',
    text: (el) => el.parent.label
  },

  ChipX: {
    tag: 'span',
    text: '✕',
    color: 'caption',
    fontSize: 'X'
  }
}
